import { SET_UNREAD_MESSAGES } from '../../reducers/conversations/chat/unreadMessages'

export const setUnreadMessages = (userId, unreadCount) => ({
  userId,
  unreadCount,
  type: SET_UNREAD_MESSAGES,
})

/**
 * Set user unread messages count.
 *
 * @param {String} user User public ID
 * @param {Number} unreadCount Number of unread messages
 */
const setUserUnreadMessages = (user, unreadCount) => (dispatch) => dispatch(setUnreadMessages(user, unreadCount))

export default {
  setUserUnreadMessages,
}
